import './App.scss';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './components/home';
import { Projects } from './components/projects';
import { Layout } from './components/Layout';
import { AboutMe } from './components/about-me';
import { ContactMe } from './components/contact-me';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about-me" element={<AboutMe />} />
          <Route path="projects" element={<Projects />} />
          <Route path="contact-me" element={<ContactMe />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
